import { cn } from "@/lib/utils";
import { FlaskConical } from "lucide-react";

// Badge discreto indicando dados de demonstração.
export const DemoBadge = ({ className }) => (
  <span
    data-testid="demo-badge"
    title="Esta interface usa dados de demonstração"
    className={cn(
      "inline-flex items-center gap-1.5 rounded-full border border-line bg-white/[0.03] px-2.5 py-1 text-[11px] font-medium text-muted-foreground",
      className,
    )}
  >
    <FlaskConical className="h-3 w-3 text-brand/80" />
    Dados de demonstração
  </span>
);
